import { StoreBuTypeEnum } from '@inter-ikea-kompis/enums';
import ServiceFetch from '../../utilities/ServiceFetch.js';
/**
 * This class is used for fetching a list of stores for a market.
 */
export default class DexfStoreService {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.endpoint Endpoint.
     * @param options.dexfApiKey DEXF Api ket.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.dexfApiKey = options.dexfApiKey;
    }
    /**
     * Returns stores from a retail unit/market.
     *
     * @returns Promise.
     */
    async getStores() {
        const options = {
            credentials: 'same-origin',
            headers: {
                'dexf-api-key': this.dexfApiKey
            }
        };
        const response = await ServiceFetch.json(this.endpoint, options);
        if (!response) {
            return [];
        }
        const stores = [];
        for (const store of response.stores) {
            // Filtering the store types.
            if (store.buType === StoreBuTypeEnum.store ||
                store.buType === StoreBuTypeEnum.office ||
                store.buType === StoreBuTypeEnum.smallStore ||
                store.buType === StoreBuTypeEnum.shop) {
                stores.push(this.parseStoreItem(store));
            }
        }
        return stores;
    }
    /**
     * Parses store data.
     *
     * @param store Response store.
     * @returns Item string.
     */
    parseStoreItem(store) {
        return {
            id: store.code,
            name: store.storeText,
            location: {
                latitude: store.latitude,
                longitude: store.longitude
            }
        };
    }
}
//# sourceMappingURL=DexfStoreService.js.map